package com.essntl.features.proposal.domain.utils

import kotlin.math.roundToInt

fun calculateIntMerchantFee(amount: Int): Int {
    val feePercentage = 3.5f / 100f
    return (amount * feePercentage).roundToInt()
}